// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"158e6571","453":"4870b739","622":"4008abb8"}[chunkId] + ".chunk.js";
};